export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10978.e52ef67a.jpg";